<template>
  <page-wrapper background="/static/img/anniversary/page-meet/bg.png" :swiper="swiper" :hasDownBtn="true">
    <div class="main-text ani" swiper-animate-effect="animate__fadeIn" v-if="dataInfo">
      Hi，<span class="text-highline">{{customerName}}</span>老师<br />
      <span class="text-highline">{{dataInfo.registrationDate}}</span>，您第一次与吉凯相遇<br />
      我们共同走过了<span class="text-highline">{{dataInfo.registrationDatetoToday}}</span><br />
      <span v-if="dataInfo.registrationDateYear > 0">科研路漫漫，过程中体会到了坚持的力量<br />不忘初心，我们继续携手探索科研的奥秘</span>
      <span v-else>希望我们来日方长<br/>我们携手并进，继续创造无限可能</span>
    </div>
    <div class="main-text ani" swiper-animate-effect="animate__fadeIn" v-else>
      Hi，<span class="text-highline">{{customerName}}</span>老师<br />
      <span class="text-highline">{{customerCreateDT}}</span>今天是您第一次与吉凯相遇<br />
      终于等到您了~<br />
      未来日子里吉凯陪您「研途可期」
    </div>
    <img class="main-image ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/shape01.png" />
  </page-wrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import PageWrapper from '../PageWrapper.vue'
export default {
  components: { PageWrapper },
  computed: {
    ...mapGetters(['customerName', 'customerCreateDT']),
    dataInfo () {
      return this.data
    }
  },
  props: [
    'swiper', 'data'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .main-text {
    position: absolute;
    left: 9.333333333vw;
    top: 55.2vw;
    width: 85vw;
    font-size: 4.26vw;
    line-height: 9.33vw;
    font-weight: 400;
    letter-spacing: -0.3px;

    /* 字体 */
    color: #193543;

    .text-highline {
      font-size: 22px;
      font-weight: 600;
    }
  }

  .main-image {
    position: absolute;
    left: 50vw;
    margin-left: -46.265vw;
    bottom: 10.66666667vw;
    width: 92.53vw;
    height: 65.86666667vw;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?08ba4f50